import styled from 'styled-components/macro';

export const ViewPort = styled.div`
  display: flex;
  justify-content: center;
`;

export const Container = styled.div`
  @media (min-width: 768px) {
    display: flex;
    flex-wrap: wrap;
    width: 764px;
  }

  @media (min-width: 1200px) {
    width: 1146px;
  }

  @media (min-width: 1920px) {
    width: 1910px;
  }
`;

